(() => {
  if (window.xtraCampaignInitialized) return;
  window.xtraCampaignInitialized = true;
  const instances = new WeakMap();
  const mount = root => {
    if (instances.has(root)) return;
    document.body.classList.add('xcp-campaign-page');
    const nav = root.querySelector('.xcp-nav');
    const header = document.querySelector('.shopify-section--header')
      || document.querySelector('#shopify-section-header')
      || document.querySelector('store-header')?.closest('.shopify-section')
      || document.querySelector('store-header, x-header');
    const topBar = document.querySelector('.shopify-section--top-bar');
    const updateOffset = () => {
      let offset = 0;
      if (header) {
        const bounds = header.getBoundingClientRect();
        const position = getComputedStyle(header).position;
        if (['sticky', 'fixed'].includes(position) && bounds.bottom > 0) {
          offset = bounds.bottom;
        } else {
          offset = header.offsetHeight || 0;
        }
      }
      root.style.setProperty('--xcp-header-offset', `${Math.max(0, Math.floor(offset) - 2)}px`);
      const heroOffset = (header?.offsetHeight || 0) + (topBar?.offsetHeight || 0);
      root.style.setProperty('--xcp-hero-header-offset', `${Math.max(0, Math.floor(heroOffset) - 2)}px`);
    };
    updateOffset();
    const resize = new ResizeObserver(updateOffset);
    if(header) resize.observe(header);
    if(topBar) resize.observe(topBar);
    const controller = new AbortController();
    window.addEventListener('scroll',updateOffset,{passive:true,signal:controller.signal});
    const links=[...root.querySelectorAll('.xcp-nav a[href^="#"]')];
    const purchaseButtons=[...root.querySelectorAll('.xcp-sku-actions .xcp-button, .xcp-table a')];
    const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
    const mobileView=matchMedia('(max-width: 749px)');
    const centerInRail=(item,behavior='smooth')=>{
      const rail=item?.parentElement;
      if(!rail||rail.scrollWidth<=rail.clientWidth)return;
      const left=item.offsetLeft-(rail.clientWidth-item.offsetWidth)/2;
      rail.scrollTo({left:Math.max(0,left),behavior});
    };
    root.querySelectorAll('[data-xcp-switcher]').forEach(switcher=>{
      const tabs=[...switcher.querySelectorAll('[role="tab"]')];
      const panels=[...switcher.querySelectorAll('[role="tabpanel"]')];
      if(!tabs.length||tabs.length!==panels.length)return;
      const activate=(index,center=true)=>{
        tabs.forEach((tab,i)=>{
          const on=i===index;
          tab.setAttribute('aria-selected',String(on));
          tab.tabIndex=on?0:-1;
          panels[i].hidden=!on;
        });
        if(center&&mobileView.matches)requestAnimationFrame(()=>centerInRail(tabs[index],reducedMotion.matches?'auto':'smooth'));
      };
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>activate(i),{signal:controller.signal});
        tab.addEventListener('keydown',event=>{
          let next=i;
          if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%tabs.length;
          else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+tabs.length)%tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=tabs.length-1;
          else return;
          event.preventDefault();
          activate(next);
          tabs[next].focus();
        },{signal:controller.signal});
      });
      const selected=Math.max(0,tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true'));
      if(mobileView.matches)requestAnimationFrame(()=>centerInRail(tabs[selected],'auto'));
    });
    if(mobileView.matches)root.querySelectorAll('details.xcp-term').forEach(detail=>{detail.open=false;});
    let frame=0;
    const avoidWidgets=()=>{
      frame=0;
      const overlaps=purchaseButtons.some(button=>{
        const box=button.getBoundingClientRect();
        return box.width>0 && box.right>innerWidth-380 && box.bottom>innerHeight-330 && box.top<innerHeight;
      });
      document.body.classList.toggle('xcp-purchase-focus',overlaps);
    };
    const scheduleWidgets=()=>{if(!frame)frame=requestAnimationFrame(avoidWidgets);};
    window.addEventListener('scroll',scheduleWidgets,{passive:true,signal:controller.signal});
    window.addEventListener('resize',scheduleWidgets,{passive:true,signal:controller.signal});
    avoidWidgets();
    const pairs=links.map(a=>{
      const el=document.getElementById(a.hash.slice(1));
      return el?{a,el}:null;
    }).filter(Boolean);
    links.forEach(a=>{if(!pairs.some(pair=>pair.a===a))a.hidden=true;});
    const stickyStack=()=>{
      updateOffset();
      const headerOffset=parseFloat(getComputedStyle(root).getPropertyValue('--xcp-header-offset'))||0;
      const navHeight=nav?.getBoundingClientRect().height||0;
      return headerOffset+navHeight;
    };
    let currentNavId=null;
    const setCurrent=id=>{
      links.forEach(a=>{
        if(id&&a.hash===`#${id}`)a.setAttribute('aria-current','true');
        else a.removeAttribute('aria-current');
      });
      if(id&&id!==currentNavId&&mobileView.matches){
        const active=links.find(a=>a.hash===`#${id}`);
        if(active)requestAnimationFrame(()=>centerInRail(active,reducedMotion.matches?'auto':'smooth'));
      }
      currentNavId=id;
    };
    let pinnedId=null;
    let pinTimer=0;
    const syncNav=()=>{
      if(pinnedId)return;
      const probe=stickyStack()+10;
      let current=null;
      pairs.forEach(({a,el})=>{
        const bounds=el.getBoundingClientRect();
        if(bounds.top<=probe+1&&bounds.bottom>probe)current=a.hash.slice(1);
      });
      setCurrent(current);
    };
    let spyFrame=0;
    const scheduleSpy=()=>{if(!spyFrame)spyFrame=requestAnimationFrame(()=>{spyFrame=0;syncNav();});};
    window.addEventListener('scroll',scheduleSpy,{passive:true,signal:controller.signal});
    window.addEventListener('resize',scheduleSpy,{passive:true,signal:controller.signal});
    const scrollToSection=(target,behavior='smooth')=>{
      const visual=target.querySelector('.xcp-board')||target;
      const top=Math.ceil(visual.getBoundingClientRect().top+window.scrollY-stickyStack()-10)+1;
      window.scrollTo({top:Math.max(0,top),behavior});
    };
    const pinUntilSettled=id=>{
      pinnedId=id;
      setCurrent(id);
      window.clearTimeout(pinTimer);
      pinTimer=window.setTimeout(()=>{pinnedId=null;syncNav();},900);
    };
    root.addEventListener('click', event => {
      const anchor=event.target.closest('a[href^="#"]');
      if(!anchor)return;
      const target=document.getElementById(anchor.hash.slice(1));
      if(!target)return;
      event.preventDefault();
      pinUntilSettled(target.id);
      scrollToSection(target,reducedMotion.matches?'instant':'smooth');
      history.replaceState(null,'',anchor.hash);
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    },{signal:controller.signal});
    if(location.hash){
      const initialTarget=document.getElementById(location.hash.slice(1));
      if(initialTarget&&pairs.some(pair=>pair.el===initialTarget)){
        pinUntilSettled(initialTarget.id);
        requestAnimationFrame(()=>scrollToSection(initialTarget,'instant'));
      }
    }
    syncNav();
    const ends=Date.parse(root.dataset.end);
    if(Number.isFinite(ends)&&Date.now()>ends){
      root.dataset.expired='true';
      root.querySelectorAll('[data-active-copy]').forEach(el=>el.hidden=true);
      root.querySelectorAll('[data-ended-copy]').forEach(el=>el.hidden=false);
    }
    instances.set(root,()=>{resize.disconnect();controller.abort();cancelAnimationFrame(frame);cancelAnimationFrame(spyFrame);window.clearTimeout(pinTimer);document.body.classList.remove('xcp-purchase-focus','xcp-campaign-page');instances.delete(root);});
  };
  const init=()=>document.querySelectorAll('[data-xtra-campaign]').forEach(mount);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-xtra-campaign]').forEach(el=>instances.get(el)?.()));
})();
